export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImI0ZjM5ZDRkLTczZDUtNGZmNi1hYWQxLTI3OGZiNTIzNGIzYyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.WgWIrbCBRXzU+sNg7Dj2/nn+AMu1GtcA2tLnYHXtGoy9Vr6+cMRO9ioPSqFbDKjAkIxL8vfb43AEeKSEL9lYOUaWzY2xFdujL5XrpuRQZrnoETbtcFQJPJgq7SLtqmjUsWCVTA==';
